export default __webpack_public_path__ + "static/media/gallery_03.c4e34f34.jpg";